import React, { useEffect, useState } from 'react'
import { ReactComponent as UsersIcon } from '../../../assets/icons/users.svg'
import { ReactComponent as InHouse } from '../../../assets/icons/inhouse.svg'
import { ReactComponent as MoreIcon } from '../../../assets/icons/more.svg'
import {
    changeDateFormat,
    convertTimeToLocal,
    setBreadCrumbRoutes
} from '../../helpers/Util'

import DeleteFolderModal from '../common/DeleteFolderModal'
import { useNavigate } from 'react-router-dom'
import Image from '../../common/Image'

const FolderCardView = ({ folderInfo, removeItem, setSelectedId }) => {
    const [item, setItem] = useState(folderInfo)
    const [isShowRemoveModal, setIsShowRemoveModal] = useState(false)
    const [isShowMore, setIsShowMore] = useState(false)
    const [folderName, setFolderName] = useState('')

    const navigate = useNavigate()

    useEffect(() => {
        setFolderName(item.name)
    }, [item])

    const removeFolder = () => {
        removeItem(item.id)
        setIsShowRemoveModal(false)
    }

    const onClickCard = () => {
        let newRoute = `/favourites/${item.id || 'my-favourite'}`
        let visitingRoutes = [
            {
                key: '/favourites',
                value: 'Favourites'
            },
            {
                key: newRoute,
                value: item.name
            }
        ]

        setBreadCrumbRoutes(visitingRoutes)
        navigate(newRoute)
    }

    const isMyFavourite = (folderId) => folderId === -1

    return (
        <>
            <div
                className='collection-card'
                onMouseLeave={() => setIsShowMore(false)}
            >
                <div className='product-img-container' onClick={onClickCard}>
                    <div className='prev-img'>
                        {item?.documents?.[0] && (
                            <Image
                                src={item.documents[0]}
                                alt='style'
                                isStatic={false}
                            />
                        )}
                        {!item?.documents?.[0] && (
                            <Image
                                src='/images/default_product.svg'
                                alt='style'
                            />
                        )}
                    </div>
                    <div className='prev-img-thumb'>
                        <div className='single-first'>
                            {item?.documents?.[1] && (
                                <Image
                                    src={item.documents[1]}
                                    alt='style'
                                    isStatic={false}
                                />
                            )}
                            {!item?.documents?.[1] && (
                                <Image
                                    src='/images/default_product.svg'
                                    alt='style'
                                />
                            )}
                        </div>
                        <div className='single-second'>
                            {item?.documents?.[2] && (
                                <Image
                                    src={item.documents[2]}
                                    alt='style'
                                    isStatic={false}
                                />
                            )}
                            {!item?.documents?.[2] && (
                                <Image
                                    src='/images/default_product.svg'
                                    alt='style'
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className='collection-status'>
                    {item?.isShared === true && (
                        <span className='status pink-1 mr-2'>
                            <UsersIcon />
                        </span>
                    )}
                    {item?.fromBuyerSelection && (
                        <span className='status blue-1 mr-2'>
                            <InHouse />
                        </span>
                    )}
                    {item?.fromRange && item?.id && (
                        <span className='status purple-1 mr-2'>Range</span>
                    )}
                </div>
                <div className='more-options absolute right-4 top-3'>
                    {!isMyFavourite(item?.id) && item?.id && (
                        <div className='common-dropdown from-right'>
                            <button
                                className={`button secondary icon-only bg-white ${
                                    item?.name === 'Sold Interest'
                                        ? 'cursor-none'
                                        : ''
                                }`}
                                onClick={() => setIsShowMore((prev) => !prev)}
                            >
                                <MoreIcon />
                            </button>
                            {isShowMore && (
                                <div className='dropdown-box dropdown-menu scroll-y-label'>
                                    <div className='list-items scroll-y-label'>
                                        <div
                                            className='single-item'
                                            onClick={() =>
                                                setSelectedId(item.id)
                                            }
                                        >
                                            <p className='whitespace-nowrap'>
                                                Edit folder
                                            </p>
                                        </div>
                                        <div
                                            className='single-item'
                                            onClick={() =>
                                                setIsShowRemoveModal(true)
                                            }
                                        >
                                            <p className='text-nowrap'>
                                                Delete folder
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className='collection-content d-flex justify-between items-center'>
                    <div className='w-full'>
                        {/* {selectedId === item?.id && (
                            <input
                                type='text'
                                value={folderName}
                                onChange={(e) => setFolderName(e.target.value)}
                                onBlur={changeFolderName}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        changeFolderName(e)
                                    }
                                }}
                                autoFocus={true}
                            />
                        )} */}
                        <h3 className='collection-title'>
                            <span>{item?.name}&nbsp;</span>

                            {item.isNew && (
                                <span className='status blue-3'>
                                    New {item.numberOfNewProduct}
                                </span>
                            )}
                        </h3>
                        <div className='details-info'>
                            <ul className='common-list-component'>
                                <li>
                                    {convertTimeToLocal(
                                        changeDateFormat(
                                            item.createdAt?.split('T')[0],
                                            '',
                                            'DD/MM/YYYY'
                                        ),
                                        item.createdAt?.split('T')[1],
                                        'h:mm A'
                                    )}
                                </li>
                                <li>
                                    {changeDateFormat(
                                        item?.createdAt,
                                        '',
                                        'DD MMM, YY'
                                    )}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                {isShowRemoveModal && (
                    <DeleteFolderModal
                        isShowModal={isShowRemoveModal}
                        closeModal={() => setIsShowRemoveModal(false)}
                        removeFolder={removeFolder}
                    />
                )}
            </div>
        </>
    )
}

export default FolderCardView
